import { Button, Stack, Typography } from "@mui/material";
import { useAtomValue } from "jotai/index";
import { LicenseRequestViewAtom } from "../../atoms";
import React from "react";
import AnimationSuccess from "../lottie-animations/AnimationSuccess";
import { Link } from "react-router-dom";

export const LicenseRequestSended = () => {
  const licenseRequest = useAtomValue(LicenseRequestViewAtom);

  const recipient = licenseRequest?.firstName || licenseRequest?.lastName
    ? `${licenseRequest?.firstName} ${licenseRequest?.lastName}`.trim()
    : licenseRequest?.email;

  return (
    <Stack direction={"column"} gap={2}>
      <Typography variant="h2" fontWeight={700} align="center" gutterBottom>
        License Sent
      </Typography>
      <AnimationSuccess />
      <Typography fontWeight={400} maxWidth="sm" sx={{ mx: "auto" }} className="text-grey" align="center">
        You have successfully sent the license to <Typography component="b" fontWeight={700}>{recipient}</Typography>.
        The recipient will now be able to <b>review</b> the license and <b>accept or decline</b> it.
      </Typography>
    </Stack>
  );
};
